/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$sitelink-link-font-size: 14px !default;
$sitelink-link-line-height: 18px !default;
$sitelink-link-font-weight: 400 !default;
$sitelink-headline-link-font-size: 18px !default;
$sitelink-headline-link-line-height: 24px !default;
$sitelink-headline-link-font-weight: 700 !default;
$sitelink-border-bottom-width: 1px !default;
$sitelink-link-padding: 8px 0px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  font-family: $font-family-base;
}

::slotted([slot="links"]) {
  display: flex;
  text-align: left;
  padding: $sitelink-link-padding !important;
  --fontWeight: #{$sitelink-link-font-weight};
  --fontSize: #{$sitelink-link-font-size};
  --lineHeight: #{$sitelink-link-line-height};
  --minHeight: auto;
  --borderBottomWidth: #{$sitelink-border-bottom-width};
  --contentColor: var(--linkColor) !important;
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted([slot="headline-link"]) {
  display: flex;
  text-align: left;
  --fontWeight: #{$sitelink-headline-link-font-weight};
  --fontSize: #{$sitelink-headline-link-font-size};
  --lineHeight: #{$sitelink-headline-link-line-height};
  --minHeight: auto;
  --borderBottomWidth: #{$sitelink-border-bottom-width};
  --contentColor: var(--headlineLinkColor) !important;
  --contentHoverColor: var(--headlineLinkHoverColor) !important;
  --contentFocusColor: var(--headlineLinkHoverColor) !important;
}

@include for-size(phone) {
  ::slotted([slot="headline-link"]) {
    --fontSize: #{$sitelink-link-font-size};
    --lineHeight: #{$sitelink-link-line-height};
  }
}

@include for-size(tablet) {
  ::slotted([slot="links"]) {
    position: relative;
    white-space: break-spaces;
    -moz-page-break-inside: avoid;
    -moz-column-break-inside: avoid;
    -webkit-column-break-inside: avoid;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  ::slotted([slot="headline-link"]) {
    --fontSize: 14px;
    --lineHeight: 18px;
  }

  .#{$prefix}links {
    position: relative;
    -moz-column-count: 3;
    -moz-column-gap: 24px;
    -webkit-column-count: 3;
    -webkit-column-gap: 24px;
    column-count: 3;
    column-gap: 50px;
  }
}
